import { c as _c } from "react/compiler-runtime";
import { SRatingButton, SRatingContainer, SRatingStar } from "src/components/filmwebid/CSSPanelStyles";
import FlyoutPanel from "src/components/flyoutpanel/FlyoutPanel";
import StarSvg from "src/components/svg/StarSvg";
import type { IMovieStats } from "src/lib/filmwebid/IMovieActivity";
import getFraction from "src/lib/filmwebid/getFraction";
import useRating from "src/lib/filmwebid/useRating";
import type { IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";
import styles from './RatingPanel.module.css';
import { useCallback } from "react";
import { times } from "lodash";
import { locale } from "@locale";
import { formatLocaleString } from "src/lib/locale/helpers";

//#region [Props]
type RatingPanelProps = {
  onClose: (doUpdate: boolean) => void;
  movieIdentifier: IFilmwebIdMovieIdentifier | null | undefined;
  userRating?: number;
  hasUserReview?: boolean;
  movieStats?: IMovieStats;
  maxRatingValue: number;
};
//#endregion

//#region [Component]
export default function RatingPanel(t0) {
  const $ = _c(51);
  const {
    movieIdentifier,
    userRating,
    onClose,
    hasUserReview: t1,
    movieStats,
    maxRatingValue
  } = t0;
  const hasUserReview = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== movieIdentifier || $[1] !== userRating) {
    t2 = {
      movieIdentifier,
      initialValue: userRating
    };
    $[0] = movieIdentifier;
    $[1] = userRating;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [rater, isSavingRating, rating, isDoneSavingRating] = useRating(t2);
  let t3;
  if ($[3] !== hasUserReview || $[4] !== rater) {
    t3 = (newRating, oldRating) => {
      if (newRating === oldRating) {
        if (!hasUserReview) {
          rater(0);
        }
      } else {
        rater(newRating);
      }
    };
    $[3] = hasUserReview;
    $[4] = rater;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toggleRating = t3;
  let T0;
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== isDoneSavingRating || $[7] !== isSavingRating || $[8] !== maxRatingValue || $[9] !== movieStats?.ratingAverage || $[10] !== onClose || $[11] !== rating || $[12] !== toggleRating || $[13] !== userRating) {
    const ratingNumberer = times(maxRatingValue, _temp);
    T0 = FlyoutPanel;
    if ($[22] !== onClose || $[23] !== rating || $[24] !== userRating) {
      t6 = () => onClose(rating !== userRating);
      $[22] = onClose;
      $[23] = rating;
      $[24] = userRating;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    t7 = isDoneSavingRating;
    const t11 = userRating ? locale.ratings.yourRating : locale.ratings.headingCta;
    if ($[26] !== t11) {
      t8 = <h3 className={styles.SHeading}>{t11}</h3>;
      $[26] = t11;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    let t12;
    if ($[28] !== isSavingRating || $[29] !== rating || $[30] !== toggleRating) {
      t12 = i_0 => <SRatingButton key={`rb1_${i_0}`} onClick={() => toggleRating(i_0, rating)} disabled={isSavingRating}><SRatingStar selected={(rating ?? 0) >= i_0} /></SRatingButton>;
      $[28] = isSavingRating;
      $[29] = rating;
      $[30] = toggleRating;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    t9 = <SRatingContainer className={styles.SRatingContainer}>{ratingNumberer.map(t12)}</SRatingContainer>;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <h3 className={styles.SHeading}>{locale.ratings.headingAvg}</h3>;
      $[32] = t10;
    } else {
      t10 = $[32];
    }
    t4 = styles.SAverageContainer;
    let t13;
    if ($[33] !== movieStats?.ratingAverage) {
      t13 = i_1 => <StarSvg key={`rb2_${i_1}`} fractionSelected={getFraction(movieStats?.ratingAverage, i_1)} />;
      $[33] = movieStats?.ratingAverage;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    t5 = ratingNumberer.map(t13);
    $[6] = isDoneSavingRating;
    $[7] = isSavingRating;
    $[8] = maxRatingValue;
    $[9] = movieStats?.ratingAverage;
    $[10] = onClose;
    $[11] = rating;
    $[12] = toggleRating;
    $[13] = userRating;
    $[14] = T0;
    $[15] = t10;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[14];
    t10 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t11;
  if ($[35] !== t4 || $[36] !== t5) {
    t11 = <div className={t4}>{t5}</div>;
    $[35] = t4;
    $[36] = t5;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== movieStats) {
    t12 = movieStats?.ratingAverage ? formatLocaleString(locale.ratings.ratingAverage, {
      ratingCount: (movieStats.ratingCount ?? 0).toString(),
      ratingAverage: (movieStats.ratingAverage ?? 0).toFixed(1)
    }) : locale.ratings.noRating;
    $[38] = movieStats;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t12) {
    t13 = <div className={styles.SAverageText}>{t12} </div>;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== T0 || $[43] !== t10 || $[44] !== t11 || $[45] !== t13 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t14 = <T0 onAfterCloseComplete={t6} isClosed={t7}>{t8}{t9}{t10}{t11}{t13}</T0>;
    $[42] = T0;
    $[43] = t10;
    $[44] = t11;
    $[45] = t13;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  return t14;
}
//#endregion

//#region [Styles]
// Converted to CSS Modules (RatingPanel.module.css)
//#endregion
function _temp(i) {
  return i + 1;
}